import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  border: none;
  background-color: transparent;
   color: ${(props) => (props.gradient ? '#ffffff' : '#5266e3')};
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  p {
    font-size: 12px;
     color: ${(props) => (props.gradient ? '#ffffff' : '#5266e3')};
     font-weight: 600;
  }
svg {
    fill: ${(props) => (props.gradient ? '#ffffff' : '#5266e3')};

}
  :hover {
  color: #FF6C37;
  }
  :active,
  :focus,
  :focus-visible,
  svg:focus {
    border: none;
    outline: none;
  }

`;

/* eslint-disable react/prop-types */
function ButtonCopy({ duration = 3000, gradient }) {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutIdRef = useRef(null);
  const [buttonId, setButtonId] = useState('');
  const handleClick = () => {
    const url = window.location.href; // Use the current page URL
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setIsCopied(true);
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => {
          setIsCopied(false);
        }, duration); // Reset text after the specified duration
      })
      .catch((err) => {
        /* eslint-disable no-console */
        console.error('Failed to copy: ', err);
        /* eslint-enable */
      });
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutIdRef.current);
    };
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pageUrl = window.location.pathname
        .replace(/^\//, '') // Remove the leading slash
        .replace(/\/+/g, '-') // Replace subsequent slashes with dashes
        .replace(/-$/, ''); // Remove trailing dash if it exists

      setButtonId(`copy-button-${pageUrl}`);
    }
  }, []);

  if (!buttonId) {
    return null; // Render nothing on the server
  }
  return (
    <StyledButton onClick={handleClick} gradient={gradient} id={buttonId}>
      {isCopied ? (
        <p className=" mb-0">copied!</p>
      ) : (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.54388 19.694C6.80271 21.4353 3.96205 21.4353 2.22089 19.6941C0.479728 17.953 0.479727 15.1123 2.22106 13.3712L6.17288 9.41934C7.83288 7.75934 10.4869 7.66767 12.2427 9.17834C12.4122 9.32334 12.517 9.52967 12.5345 9.752C12.5519 9.97433 12.4802 10.1945 12.3352 10.364C12.1904 10.5335 11.984 10.6385 11.7617 10.6558C11.5394 10.6732 11.3192 10.6015 11.1497 10.4567C10.0447 9.50584 8.41221 9.551 7.35838 10.6048L3.40655 14.5567C2.30156 15.6617 2.30156 17.4037 3.40655 18.5085C4.51138 19.6135 6.25338 19.6135 7.35838 18.5085L11.1125 14.7542C11.19 14.6748 11.2825 14.6115 11.3847 14.5682C11.4869 14.5247 11.5965 14.502 11.7075 14.5012C11.8185 14.5005 11.9285 14.5218 12.0312 14.564C12.1339 14.6062 12.227 14.6683 12.3055 14.7468C12.384 14.8253 12.4462 14.9185 12.4884 15.0212C12.5305 15.1238 12.5519 15.2338 12.551 15.3448C12.5504 15.4558 12.5277 15.5655 12.4842 15.6677C12.4409 15.7698 12.3775 15.8623 12.2982 15.9398L8.54388 19.694ZM15.6572 12.5807C13.9972 14.2407 11.3432 14.3323 9.58737 12.8215C9.50304 12.75 9.43354 12.6623 9.38288 12.5638C9.33238 12.4653 9.30188 12.3578 9.29304 12.2475C9.28421 12.137 9.29721 12.026 9.33138 11.9207C9.36554 11.8153 9.42004 11.7178 9.49204 11.6337C9.56404 11.5495 9.65187 11.4803 9.75071 11.4303C9.84937 11.3802 9.95704 11.35 10.0675 11.3417C10.1779 11.3333 10.2889 11.3468 10.394 11.3813C10.4992 11.416 10.5965 11.471 10.6804 11.5433C11.7854 12.494 13.4177 12.449 14.4717 11.3952L18.4235 7.44334C19.5285 6.33834 19.5285 4.59635 18.4235 3.49151C17.3187 2.38652 15.5767 2.38652 14.4717 3.49151L10.7175 7.24584C10.64 7.32551 10.5475 7.38884 10.4454 7.43251C10.3432 7.47617 10.2334 7.49901 10.1222 7.49984C10.0112 7.50051 9.90104 7.47934 9.79821 7.43717C9.69538 7.39501 9.60204 7.33284 9.52354 7.25417C9.44488 7.17567 9.38271 7.08234 9.34054 6.97951C9.29838 6.87667 9.27721 6.76651 9.27788 6.65551C9.27871 6.54434 9.30154 6.43451 9.34521 6.33234C9.38887 6.23018 9.45221 6.13768 9.53187 6.06018L13.2862 2.30602C15.0274 0.564688 17.868 0.564689 19.6092 2.30585C21.3503 4.04702 21.3504 6.88767 19.609 8.62884L15.6572 12.5807Z" fill="currentColor" stroke="#5075F6" strokeWidth="0.3" />
        </svg>

      )}
    </StyledButton>
  );
}

export default ButtonCopy;
/* eslint-enable react/prop-types */
